import { render, staticRenderFns } from "./Devices.vue?vue&type=template&id=315e4c2e&scoped=true&"
import script from "./Devices.vue?vue&type=script&lang=js&"
export * from "./Devices.vue?vue&type=script&lang=js&"
import style0 from "./Devices.vue?vue&type=style&index=0&id=315e4c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e4c2e",
  null
  
)

export default component.exports